<div class="input-wrapper" [class.select]="colorPickerShow" [class.light]="light">
    <input
        #colorInput
        readonly
        (click)="colorClick()"
        (colorPickerOpen)="colorPickerOpen()"
        (colorPickerClose)="colorPickerClose()"
        (colorPickerChange)="colorChange($event)"
        (cpToggleChange)="onPickerStateChange($event)"
        [cpIgnoredElements]="ignoredElements"
        [(colorPicker)]="color"
        cpAlphaChannel="hex"
        cpOutputFormat="hex"
        [style.width]="colorBoxWidth"
        [class.light]="light"
        class="color-selector-box" />
    <input
        #alphaInput
        class="alpha"
        type="number"
        [readOnly]="isReadonly"
        [(ngModel)]="alpha"
        [class.light]="light"
        (focus)="inputFocus()"
        (blur)="inputBlur()"
        (ngModelChange)="alphaChanged($event)"
        max="100"
        min="0" />
    <p class="unit" [class.light]="light">%</p>
    <mat-icon class="end-icon" [class.show]="endIcon" [svgIcon]="endIcon" (click)="minusButtonClick()"></mat-icon>
</div>
